import { render } from "./FreelancerCategories.vue?vue&type=template&id=3d344834&scoped=true"
import script from "./FreelancerCategories.vue?vue&type=script&lang=js"
export * from "./FreelancerCategories.vue?vue&type=script&lang=js"

import "./FreelancerCategories.vue?vue&type=style&index=0&id=3d344834&scoped=true&lang=scss"

import exportComponent from "/home/forge/s.thebuyhive.com/expertsourcing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d344834"]])

export default __exports__